<template>
    <div class="tabs">
        <Tab
                v-for="(tab, i) in showFilterTabs(filterTabs)"
                :key="tab.id"
                :tab="tab"
                :is-active="currentTab && currentTab.id === tab.id"
                :is-editable="tab.editable"
                @onChangeTab="onChangeTab"
                :data-v-step="i === 3 ? 'filter-tab-last' : 'filter-tab'"
        />
    </div>
</template>

<script>
    import Tab from "@/components/common/Tab"
    import {mapActions, mapGetters} from "vuex"
    import {purchasesPath} from "@/router/purchases"

    export default {
        name: "TabList",
        components: {
            Tab
        },
        data() {
            return {purchasesPath}
        },
        computed: {
            ...mapGetters('filterTabs', ['filterTabs', 'currentTab']),
            ...mapGetters('tags',['tags']),
        },
        methods: {
            ...mapActions('filterTabs', ['setCurrentTab']),
            onChangeTab(tab) {
                this.$emit('onChangeTab', tab)
            },
            hideFavorites(tab) {
                return tab.filterType !== 'FAVORITES'
            },
            filterHidden(tab) {
                return tab.filterType !== 'HIDDEN' || this.$route.path === `${purchasesPath}/${tab.id}`
            },
            filterTags(tab) {
                return tab.filterType !== 'TAG' || this.$route.path === `${purchasesPath}/${tab.id}`
            },
            showFilterTabs(tabs) {
                return tabs.filter((tab) => this.filterHidden(tab) && this.hideFavorites(tab) && this.filterTags(tab))
            }
        },
    }
</script>

<style scoped lang="less">

    .tabs {
        width: calc(100% - 190px - 48px - 24px);
        height: 48px;
        flex-shrink: 1;
        flex-grow: 1;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        border-bottom: 1px solid #eeeeee;

    }

</style>
